import { observable, action } from 'mobx';

import { ConnectionAppManager, Variables } from 'core/index';

import { ChannelsApp } from 'apps/channel/app';
import { ChannelsQuery } from 'apps/channel/gql';

import i18next from 'i18next';

export class ChannelConnManager extends ConnectionAppManager {
  static ArrayApp = ChannelsApp;
  @observable sortBy;
  @observable sortOptions;
  constructor(parent, init) {
    super(parent, init);
    this.initialBatchSize =
      this.arrayApp.cardLayout.initialBatchSize || init.initialBatchSize;
    this.sortBy = init.sortBy || 'top';
    this.sortOptions = init.sortOptions || [['recent', i18next.t('Recent')]];
    this.batchSize = init.batchSize || 6;
    this.variables = new Variables({
      sortBy: () => this.sortBy,
      batchSize: () => {
        if (this.loadedMore) {
          return this.batchSize;
        }
        return this.initialBatchSize;
      },
      cursor: () => this.endCursor,
    });
    this.loadMoreQuery = init.loadMoreQuery || ChannelsQuery;
  }

  @action NewSlug = () => {
    this.Reset();
  };

  @action SetSort = sort => {
    this.sortBy = sort;
    this.Clear();
    this.loadMore();
  };
}
